import session from 'core/sessionxtd'
import actions from '../../../actions'

const ApiHandlers = {
  cache: {
    setItem: session.setItem,
    getItem: session.getItem,
  },
  session: {
    logoutSession: actions.auth.logoutSession
  } 
}

export default ApiHandlers
